export const domain = 'Settings';

// Field status types
export const MANDATORY = 'M';
export const OPTIONAL = 'O';
export const SKIP = 'S';
